import { MutationOptions, useMutation } from '@tanstack/react-query';
import { apiClient } from 'src/libs/axios';

export type ClaimWithdrawalTradeResponse = {
  signature: string;
};
export interface ClaimWithdrawalTradeReqData {
  tokenID: string;
  balance: number;
  chainID: number;
  publicNonce: {
    kPublic: string;
    kTwoPublic: string;
  };
  publicKey: string;
  id: number;
}

export const claimWithdrawalTrade = async (data: ClaimWithdrawalTradeReqData) => {
  const response = await apiClient.post<any>(
    `/api/v2/signatures/withdrawals/${data.id}/claims`,
    {
      publicNonce: {
        kPublic: data.publicNonce.kPublic,
        kTwoPublic: data.publicNonce.kTwoPublic,
      },
      publicKey: data.publicKey,
    },
    {
      baseURL: process.env.REACT_APP_SIGNATURE_SERVICE_API_ENDPOINT,
    },
  );
  return response.data;
};

export type UseClaimWithdrawalTradeOptions<TError = Error, TContext = unknown> = MutationOptions<
  any,
  TError,
  ClaimWithdrawalTradeReqData,
  TContext
>;

export const useClaimWithdrawalTrade = <TData = ClaimWithdrawalTradeResponse>(
  options?: UseClaimWithdrawalTradeOptions<TData>,
) => {
  return useMutation({
    mutationFn: claimWithdrawalTrade,
    // onSuccess() {
    // return queryClient.invalidateQueries({ queryKey: userKeys.allBalances(userAddress!) });
    // },
    ...options,
  });
};
